import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarIcon from 'assets/icons/calendar_24.svg?react';
import styles from './StylesDatePicker.module.scss';
import { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { useClickAwayListener } from '../../../helpers/useClickAwayListener.ts';

export type StyledDatePickerProps = {
  value: Date | null;
  onChange?: ((value: Date | null) => void) | undefined;
  errorText?: string;
  classes?: { textField?: string };
};

export const StyledDatePicker = (props: StyledDatePickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  useClickAwayListener({
    refs: [anchorRef],
    onClickAway: () => setIsOpen(false),
    ignore: (target) => {
      const popper = document.querySelector(`.${styles.popper}`);
      return !!popper?.contains(target);
    },
  });

  return (
    <div
      ref={anchorRef}
      onClick={(e) => {
        // We need to check target HTML because we don't have onOpenPickerIconClick prop for DatePicker
        // @ts-ignore
        if (e.target.outerHTML.includes('id="calendar-icon"')) {
          setIsOpen((prev) => !prev);
        }
      }}
    >
      <DatePicker
        inputFormat="dd.MM.yyyy"
        value={props.value}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onChange={(newValue: any) => props.onChange?.(newValue)}
        PopperProps={{ placement: 'bottom', className: styles.popper }}
        components={{ OpenPickerIcon: CalendarIcon }}
        renderInput={(params: any) => (
          <TextField
            {...params}
            className={clsx(styles.textField, props.classes?.textField)}
            error={!!props.errorText}
            helperText={props.errorText}
            inputProps={{
              ...params.inputProps,
              placeholder: 'DD.MM.YYYY',
            }}
          />
        )}
      />
    </div>
  );
};
